var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagIcon = function SvgFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.556 4.667V23.76h.777v-9.357l13.205-4.729L8.556 4.667zm.777 1.104 10.898 3.903-10.898 3.903V5.77z",
    fill: "#191919",
    fillRule: "evenodd"
  })));
};
export { SvgFlagIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik04LjU1NiA0LjY2N1YyMy43NmguNzc3di05LjM1N2wxMy4yMDUtNC43MjlMOC41NTYgNC42Njd6bS43NzcgMS4xMDQgMTAuODk4IDMuOTAzLTEwLjg5OCAzLjkwM1Y1Ljc3eiIgZmlsbD0iIzE5MTkxOSIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";